import { createReducer, } from 'typesafe-actions';

import { fetchMe, updateMeCarts, } from './actions';

const meInitialState = {
    isLoading: false,
    isError: false,
    errorMessage: null,
    errorCode: null,
    // TODO PB Ask about business logic which better default closed or opened bookstore.
    data: null,
};

const meReducer = createReducer(meInitialState)
    .handleAction(fetchMe.request, (state,) => ({ ...state, isLoading: true, }))
    .handleAction(fetchMe.success, (state, action) => ({
        ...state,
        isLoading: false,
        isError: false,
        data: action.payload,
    }))
    .handleAction(fetchMe.failure, (state, action) => ({
        ...state,
        isLoading: false,
        isError: true,
        errorMessage: action.payload.data?.reason ?? action.payload.message,
        errorCode: action.payload?.code,
    }))
    .handleAction(updateMeCarts, (state, action) => {
        const { channel, token, } = action.payload;

        // @ts-ignore
        const found = state?.data?.carts?.find(cart => cart.channel === channel);

        if (!found) {
            return {
                ...state,
                data: {
                    // @ts-ignore
                    ...state?.data,
                    carts: [
                        { channel, token },
                        ...state?.data.carts,
                    ],
                },
            };
        }

        return {
            ...state,
            data: {
                // @ts-ignore
                ...state?.data,
                carts: state?.data.carts.map(cart => cart.channel === channel ? { ...cart, token, } : cart),
            },
        };
    });

export default meReducer;
